define(function(require) {
  var IpsModel = require('civicsBase/ipsModel');
  const utils = require('civicsUtils/general_utilities');
  const ViewManager = require('civicsUtils/view_manager');
  return IpsModel.extend({
    validation: function(){
        this.globalConfig = ViewManager.globalConfig();
        this.RequireState = this.globalConfig.get('usesContactState') == 'Required';
      if ( this.get('tender')=='Check'){
        return {
            checkAccountNumber:function(value) {
            var msg;
            if (!value || value.trim().length == 0  ) {
              msg = 'Account number is required';
            }
            else if (/[^0-9-\s]+/.test(value)) {
              msg = 'Digits only';
            }
            if(msg)return msg;
          },
          checkAccountholder:{
            required:true,
          },
          checkIssuingBank:{
            required:true,
          },
          checkNumber:{
            required:false,
          },
          checkRoutingNumber:{
            required:true,
          },
          addressLine1:{
            required:true,
          },
          city:{
            required:true,
          },
          state:{
            required:this.RequireState,
          },
          postalCode:{
            required:true,
          }
        };
      }
      else {
        return{
          cardCvv:{
            required:true,
            maxLength: 4,
            minLength: 3,
            min: 0,
            max:9999
          },
          cardNumber:function(value) {
            var msg;
            if (!value || value.trim().length == 0  ) {
              msg = 'Card number is required';
            }
            else if (/[^0-9-\s]+/.test(value)) {
              msg = 'Digits only';
            }
            else {
              // var nCheck = 0, nDigit = 0, bEven = false;
            	// value = value.replace(/\D/g, "");
            	// for (var n = value.length - 1; n >= 0; n--) {
            	// 	var cDigit = value.charAt(n),
            	// 		  nDigit = parseInt(cDigit, 10);
            	// 	if (bEven) {
            	// 		if ((nDigit *= 2) > 9) nDigit -= 9;
            	// 	}
            	// 	nCheck += nDigit;
            	// 	bEven = !bEven;
            	// }
              // if( !(nCheck % 10) == 0) msg = 'Invalid credit card number';
            }
            if(msg)return msg;
          },
          cardholderName:{
            required:true,
          },
          month:{
            required:true,
          },
          year:function(value) {
            var msg;
            var m = this.get('month');
            if (!value || value.trim().length == 0  ) {
              msg = 'Year is required';
            }
            else if (/[^0-9-\s]+/.test(value)) {
              msg = 'Digits only';
            }
            else {
              var exp = new Date(value,m,0,0,0,0,0); // this becomes the last day of the expired month
              var now = new Date();
              now.setHours(0,0,0,0);
              if (exp < now) {
                msg = 'invalid year';
              }
              var stringExp = utils.dateTimeStringFromDate(exp);//isoFixed
              this.set('cardExpirationDate', stringExp);
            }
            if(msg)return msg;
          },
          addressLine1:{
            required:true,
          },
          city:{
            required:true,
          },
          state:{
            required:this.RequireState,
          },
          postalCode:{
            required:true,
          }
        };
      }
    }
  });
});
